import { CHANGE_APP_PROPS } from "./ActionConstants";
import APIConnector from "../provider/base/APIConnector";
import AuthService from "../provider/auth/AuthService";

export function actionFirstTime(token, firebaseToken, logout) {
	return (dispatch, getStore) => {
		APIConnector.setActionLogOut(logout);
		if (token) {
			//desloguear cuando no valga más este token
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: true,
					loadingText: "Verificando permisos..."
				}
			});
			APIConnector.defaultHeaders.Authorization = "Bearer " + token;
			AuthService.verifyToken(token)
				.then(function(resp) {
					dispatch({
						type: CHANGE_APP_PROPS,
						props: {
							loading: false,
							firstTimeFlag: true,
							loadingText: "Cargando ...",
							rol: resp.rol[0].rol,
							username: resp.email,
							firebaseToken: firebaseToken
						}
					});
				})
				.catch(function(error) {
					dispatch({
						type: CHANGE_APP_PROPS,
						props: {
							loading: false,
							loadingText: "Cargando ...",
							firstTimeFlag: true
						}
					});
					logout();
				});
		} else {
			logout();
		}
	};
}

export function actionLogin(values, success) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				login: false,
				username: values.username
			}
		});
		if (success) {
			success();
		}
	};
}

export function actionChangeAppProps(props) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: props
		});
	};
}



// WEBPACK FOOTER //
// ./src/actions/AppAction.js